import React from 'react';

import Button from 'CommonComponents/Button';

import CircleCheckIcon from 'Assets/icons/circle-check.svg';

/** The green Action pill every approval row offers on an item its viewer can decide. */
export default function ApprovalActionButton({ onClick }) {
    return (
        <small className="tw-ps-3">
            <Button variant="success" onClick={onClick}>
                <CircleCheckIcon className="tw-w-3 tw-h-3 tw-me-1" aria-hidden="true" />
                {$t('Action')}
            </Button>
        </small>
    );
}
